import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { getS3URL, handleViewsFormat } from "../../../_helpers";
import { courseActionsLabel } from "../../../_constants/staticData";
import axiosInstance from "../../../axios";
import { AuthorizedWrapper } from "../../Other/AuthorizedWrapper";
import { documentTypeUrl } from "../../../_constants/staticData";
import { useDispatch } from "react-redux";
import { courseActions } from "../../../_actions";
import Modal from "../../Other/Modal";
import Programs from "../../Program/ProgramDetails";

export const CourseItem = ({
  item,
  getApprovedCourses,
  parseAndShortDescription,
  checkbox,
  handleChangeBundle,
  allbundle,
  selectedCourses,
  showEdit = true
}) => {
  const [showModal, setShowModal] = useState({ state: false, type: "" });
  const [Bundle, setBundle] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [quickViewModal, setQuickViewModal] = useState(false)
  const [quickViewId, setQuickViewId] = useState(0)
  const [quickViewSlug, setQuickViewSlug] = useState('')
  const [quickViewData, setQuickViewData] = useState(null)
  const handleClose = (event) => {
    event.preventDefault();
    setShowModal(false);
  };

  const handleChange = () => {
    setBundle(!Bundle);
  };

  const handleShowModal = (type) => {
    setShowModal({ state: true, type: type });
  };

  const handleArchiveCourse = async (courseId) => {
    try {
      await axiosInstance.post("/course/status/update", {
        courseId: courseId,
        status: 4,
      });
      dispatch(courseActions.myCourses("all", 1, "course"));
    } catch (error) {
      console.error("Error archiving course:", error);
    }
  };

  const handleInArchiveCourse = async (courseId) => {
    try {
      await axiosInstance.post("/course/status/update", {
        courseId: courseId,
        status: 3,
      });
      dispatch(courseActions.myCourses("all", 1, "course"));
    } catch (error) {
      console.error("Error unarchiving course:", error);
    }
  };


  const slugify = (text) => {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-")
      .replace(/^-+/, "")
      .replace(/-+$/, "");
  };

  const handleViewProgram = (course) => {
    const slug = slugify(course.CourseName);
    const id = course.ID;
    setQuickViewId(id)
    setQuickViewSlug(slug)
    setQuickViewData(course)
    // navigate(`/${slug}`, { state: { course: course } });
    setQuickViewModal(true)
  };

  const handleApproveCourse = async (courseId) => {
    try {
      await axiosInstance.post(
        "/course/status/update",
        JSON.stringify({
          courseId: courseId,
          status: 3,
        }),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      dispatch(courseActions.myCourses("all", 1, "course"));
    } catch (error) {
      console.error("Error approving course:", error);
    }
  };

  const handleUnApproveCourse = async (courseId) => {
    try {
      await axiosInstance.post(
        "/course/status/update",
        JSON.stringify({
          courseId: courseId,
          status: 2,
        }),
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      dispatch(courseActions.myCourses("all", 1, "course"));
    } catch (error) {
      console.error("Error unapproving course:", error);
    }
  };


  const getSubmitCallback = (type) => {
    switch (type) {
      case "approve":
        return handleApproveCourse;
      case "unapprove":
        return handleUnApproveCourse;
      case "archive":
        return handleArchiveCourse;
      case "inarchive":
        return handleInArchiveCourse;
      default:
        return null;
    }
  };

  const courseStatusCallback = (type) => {
    switch (type) {
      case 1:
        return { className: "bg-amber-50 text-amber-800 border border-amber-200/60", text: "Draft" };
      case 2:
        return { className: "bg-slate-50 text-slate-700 border border-slate-200", text: "In Review" };
      case 3:
        return { className: "bg-neutral-900 text-white border border-neutral-950", text: "Published" };
      case 4:
        return { className: "bg-neutral-100 text-neutral-500 border border-neutral-200", text: "Archive" };
      default:
        return null;
    }
  };

  useEffect(() => {
    if (selectedCourses) {
      selectedCourses.courses.map((ele) => {
        if (ele.ID === item.ID) {
          return setBundle(true);
        } else {
          return false;
        }
      });
    }
  }, [selectedCourses]);

  // Get course thumbnail image
  const getCourseImage = () => {
    if (allbundle) {
      return item?.imageLink
        ? getS3URL(item?.imageLink)
        : documentTypeUrl.brokenImage;
    }
    return item.imageFiles && item.imageFiles.length > 0
      ? getS3URL(item.imageFiles[0]?.fileName)
      : documentTypeUrl.brokenImage;
  };

  // Generate rating stars
  const renderRatingStars = (rating) => {
    return (
      <div className="flex items-center mb-2">
        {[...Array(5)].map((_, i) => (
          <span key={i} className="mr-1">
            {i < (rating || 0) ? (
              <svg className="w-4 h-4 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            ) : (
              <svg className="w-4 h-4 text-gray-300" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            )}
          </span>
        ))}
        <span className="ml-1 text-sm font-medium text-gray-600">({rating || 0})</span>
      </div>
    );
  };

  return (
    <div
      className={`group relative overflow-hidden rounded-xl shadow-md hover:shadow-xl transition-all duration-300 mb-4 p-4 border border-neutral-100 ${Bundle ? "bg-neutral-50 border-l-4 border-neutral-900" : "bg-white"
        }`}
    >
      {/* Checkbox for bundle selection */}
      {checkbox && (
        <div className="!absolute top-4 left-4 z-10">
          <input
            type="checkbox"
            checked={Bundle}
            onChange={() => {
              handleChange(item);
              handleChangeBundle(item);
            }}
            className="w-5 h-5 rounded border-neutral-300 text-neutral-900 focus:ring-neutral-900"
          />
        </div>
      )}
      <div className="flex justify-between items-center mb-4 p-3 bg-neutral-50 rounded-xl border border-neutral-100">
        <div>
          <h3 className="text-lg md:text-xl font-bold text-neutral-900">
            {item.CourseName || ""}
          </h3>
        </div>
        <div>
          {/* {renderRatingStars(item?.rating)} */}
          {/* <div className="!absolute top-2 right-2"> */}
          <span className={`px-4 py-1.5 font-bold rounded-lg text-sm transition-all ${courseStatusCallback(item?.Status)?.className}`}>
            {courseStatusCallback(item?.Status)?.text}
          </span>
          {/* </div> */}
        </div>
      </div>
      <div className="flex flex-col md:flex-row">
        {/* Course Thumbnail - REDUCED SIZE */}

        <div className="relative w-full md:w-1/6 overflow-hidden">
          <div className="relative h-32 md:h-full overflow-hidden flex justify-center mt-2">
            <img
              src={getCourseImage()}
              alt={item.CourseName || "Course Image"}
              className="w-full h-[70%] rounded-xl object-cover object-center transition-transform duration-500 group-hover:scale-110"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = require("../../../assets/images/bgimages.webp");
              }}
            />

            {/* Status Badge */}


            {/* Bundle Label */}
            {allbundle && (
              <div className="!absolute bottom-0 left-0 right-0 bg-gradient-to-t from-neutral-900 to-transparent p-2">
                <span className="text-white font-bold text-xs">Bundle</span>
              </div>
            )}
          </div>
        </div>


        {/* Course Details - Expanded to use more space */}
        <div className="w-full md:w-5/6 px-4">
          <div className="flex justify-between items-start mb-2 mt-2">
            <div>
              <p className="text-base text-neutral-500 font-semibold">
                <span className="font-bold text-neutral-700">Category:</span>{" "}
                <span className="font-black text-neutral-900">{item?.category}</span>
              </p>
            </div>
          </div>

          {/* Course Description */}
          <div className="mb-3">
            <p
              className="text-[16px] text-neutral-600 line-clamp-2"
              dangerouslySetInnerHTML={{
                __html:
                  item?.Description?.length > 150
                    ? parseAndShortDescription(item?.Description).substring(0, 150) + "..."
                    : parseAndShortDescription(item?.Description),
              }}
            ></p>
          </div>

          {!checkbox && (
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-sm font-bold align-items-center mb-2">
              {/* Views */}
              <div className="flex flex-col items-center p-2.5 rounded-xl bg-neutral-50 border border-neutral-100 hover:bg-neutral-100/60 transition-colors">
                <p className="text-xs font-bold text-neutral-500 uppercase tracking-wider mb-1">No. of Views</p>
                <p className="text-base font-black text-neutral-900">
                  {allbundle ? "0" : handleViewsFormat(item?.courseViews === null ? 0 : item?.courseViews)}
                </p>
              </div>

              {/* Enrollments */}
              <div className="flex flex-col items-center p-2.5 rounded-xl bg-neutral-50 border border-neutral-100 hover:bg-neutral-100/60 transition-colors">
                <p className="text-xs font-bold text-neutral-500 uppercase tracking-wider mb-1">No. of Enrollments</p>
                <p className="text-base font-black text-neutral-900">
                  {allbundle
                    ? (item?.price === null ? 0 : item?.price)
                    : (item?.enrollmentCount === null ? 0 : item?.enrollmentCount)}
                </p>
              </div>

              {/* Earnings */}
              <div className="flex flex-col items-center p-2.5 rounded-xl bg-neutral-50 border border-neutral-100 hover:bg-neutral-100/60 transition-colors">
                <p className="text-xs font-bold text-neutral-500 uppercase tracking-wider mb-1">Course Fees</p>
                <p className="text-base font-black text-neutral-900">
                  &#36;{item?.EnrollmentFee === null ? 0 : item?.EnrollmentFee}
                </p>
              </div>

              {/* Created Date */}
              <div className="flex flex-col items-center p-2.5 rounded-xl bg-neutral-50 border border-neutral-100 hover:bg-neutral-100/60 transition-colors">
                <p className="text-xs font-bold text-neutral-500 uppercase tracking-wider mb-1">Created On</p>
                <p className="text-base font-black text-neutral-900">
                  {allbundle
                    ? (item?.createdAt && moment(item?.createdAt).format("MMM DD, YYYY"))
                    : (item?.CreatedOn && moment(item?.CreatedOn).format("MMM DD, YYYY"))}
                </p>
              </div>
            </div>
          )}

          {/* Action Buttons */}
          {!checkbox && (
            <div className="flex flex-wrap justify-end gap-2 mt-3 text-sm font-bold">
              <AuthorizedWrapper authorizedRoles={["Admin", "Instructor", "Institute"]}>
                {allbundle ? (
                  <>
                    <button
                      className="px-5 py-2 text-neutral-800 bg-white border border-neutral-200 hover:bg-neutral-50 rounded-xl transition-all duration-200 active:scale-95"
                      onClick={() => handleViewProgram(item)}
                    >
                      View
                    </button>

                    {showEdit &&
                      <Link
                        className="px-5 py-2 text-white bg-black hover:bg-neutral-800 rounded-xl transition-all duration-200 active:scale-95 inline-flex items-center"
                        to={{
                          pathname: "/dashboard/course/edit",
                          state: { courseId: item.id, bundle: true },
                        }}
                      >
                        Edit
                      </Link>
                    }
                  </>
                ) : (
                  <>
                    {item.Status !== 4 ? (
                      <>
                        <button
                          className="px-5 py-2 text-neutral-800 bg-white border border-neutral-200 hover:bg-neutral-50 rounded-xl transition-all duration-200 active:scale-95"
                          onClick={() => handleViewProgram(item)}
                        >
                          View
                        </button>

                        {item?.Status === 1 && courseStatusCallback(item?.Status)?.text === "Draft" && showEdit && (

                          <Link
                            className="px-5 py-2 text-white bg-black hover:bg-neutral-800 rounded-xl transition-all duration-200 active:scale-95 inline-flex items-center"
                            to={{
                              pathname: `/dashboard/coursebuilder/${item.ID}`,
                              state: { courseId: item.ID },
                            }}
                          >
                            Edit
                          </Link>
                        )}

                        {courseStatusCallback(item?.Status)?.text !== "Draft" && showEdit && (
                          <Link
                            className="px-5 py-2 text-white bg-black hover:bg-neutral-800 rounded-xl transition-all duration-200 active:scale-95 inline-flex items-center"
                            to={{
                              pathname: `/dashboard/course/edit/${item.ID}`,
                              state: { courseId: item.ID },
                            }}
                          >
                            Edit
                          </Link>
                        )}

                        {item.enrollmentCount === 0 && showEdit && (<button
                          className="px-5 py-2 text-neutral-700 bg-neutral-100 hover:bg-neutral-200 rounded-xl transition-all duration-200 active:scale-95"
                          onClick={() => handleShowModal("archive")}
                        >
                          Archive
                        </button>)}
                      </>
                    ) : (
                      (item.enrollmentCount === 0 && (
                        <button
                          className="px-5 py-2 text-white bg-black hover:bg-neutral-800 rounded-xl transition-all duration-200 active:scale-95"
                          onClick={() => handleShowModal("inarchive")}
                        >
                          Unarchive
                        </button>
                      ))
                    )}
                  </>
                )}
              </AuthorizedWrapper>

              {!allbundle && item?.Status === 2 ? (
                <AuthorizedWrapper authorizedRoles={["Admin", "Institute"]}>
                  <button
                    className="px-5 py-2 text-white bg-black hover:bg-neutral-800 rounded-xl transition-all duration-200 active:scale-95"
                    onClick={() => handleShowModal("approve")}
                  >
                    Approve
                  </button>
                </AuthorizedWrapper>
              ) : (
                item.enrollmentCount === 0 &&
                <AuthorizedWrapper authorizedRoles={["Admin", "Institute"]}>
                  <button
                    className="px-5 py-2 text-neutral-700 bg-neutral-100 hover:bg-neutral-200 rounded-xl transition-all duration-200 active:scale-95"
                    onClick={() => handleShowModal("unapprove")}
                  >
                    Unapprove
                  </button>
                </AuthorizedWrapper>
              )}
            </div>
          )}
        </div>
      </div>

      {/* Modal Overlay */}
      {showModal.state && (
        <Modal isOpen={true} onClose={handleClose}>
          <ItemActionsOverlay
            courseId={item.ID}
            handleCancel={handleClose}
            handleSubmit={getSubmitCallback(showModal.type)}
            varient={showModal.type}
          />
        </Modal>
      )}
      {
        <Modal isOpen={quickViewModal} onClose={() => setQuickViewModal(false)} width={'60%'}>
          <Programs id={quickViewId} slug={quickViewSlug} course={quickViewData} />
        </Modal>
      }
    </div>
  );
};

const ItemActionsOverlay = ({ courseId, varient, handleCancel, handleSubmit }) => {
  const [isSubmitting, setSubmitting] = useState(false);

  const handleClose = (event) => {
    handleCancel(event);
  };

  const handleSubmitCallback = (event, courseId) => {
    event.preventDefault();
    setSubmitting(true);
    handleSubmit(courseId);
  };

  return (
    <div className="bg-white rounded-2xl p-6 max-w-md w-full border border-neutral-100">
      {isSubmitting ? (
        <div className="text-center">
          <div className="my-6 flex flex-col items-center">
            <div className="rounded-full bg-green-50 border border-green-200 p-3 mb-4">
              <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-lg font-bold text-neutral-900">Course status successfully updated.</p>
          </div>
        </div>
      ) : (
        <>
          <div className="my-6">
            <p className="text-lg font-bold text-center text-neutral-900">
              {courseActionsLabel[varient]}
            </p>
          </div>
          <div className="flex justify-center gap-4 mt-6">
            <button
              onClick={handleClose}
              className="px-5 py-2.5 text-sm font-bold text-neutral-700 bg-neutral-100 hover:bg-neutral-200 rounded-xl transition-all duration-200"
            >
              CANCEL
            </button>
            <button
              onClick={(event) => handleSubmitCallback(event, courseId)}
              className="px-5 py-2.5 text-sm font-bold text-white bg-black hover:bg-neutral-800 rounded-xl transition-all duration-200"
            >
              {varient.toUpperCase()}
            </button>
          </div>
        </>
      )}
    </div>
  );
};
